module.exports = __webpack_public_path__ + "img/02e_marketing.ec604bfb.jpg";